



































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { ICalendarOutputActivity } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'CalendarActivity',

  props: {
    activities: {
      type: Array as () => ICalendarOutputActivity[],
      default: null,
    },
  },

  computed: {
    activitiesLoaded(): boolean {
      return this.activities !== null
    },
    hasActivities(): boolean {
      return this.activitiesLoaded && this.activities.length > 0
    },
  },
})
